import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/settings'

/** 获取按钮开关 */
export const getBtnListSwitch = () => {
  return axios.get(`${rootApi}/terminalButtonSettings`)
}

/** 上传按钮开关 */
export const putBtnListSwitch = (params) => {
  return axios.put(`${rootApi}/terminalButtonSettings`, params)
}

/** 获取生产工单设置列表 */
export const getWorkOrderListSwitch = () => {
  return axios.get(`${rootApi}/terminalOrderFieldSettings`)
}

/** 上传生产工单设置列表 */
export const putWorkOrderListSwitch = (params) => {
  return axios.put(`${rootApi}/terminalOrderFieldSettings`, params)
}

/* 获取项目号 */
export const getProjectNo = () => {
  return axios.get(`${rootApi}/getTaskCustomField`)
}